import axios from "axios";

const API_URL = "http://testingengaged.stmarkos.org/";


const login = (username, password) => {
  return axios
    .post(API_URL + "/api/login", {
      username,
      password,
    })
    .then((response) => {
      // console.log('el resulta', response);
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

export default {
  login,
  logout,
};
